import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import { Box, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';

// ----------------------------------------------------------------------

EntryListHead.propTypes = {
  sort: PropTypes.oneOf(['asc', 'desc']),
  sortBy: PropTypes.string,
  headLabel: PropTypes.array,
  onRequestSort: PropTypes.func
};

export default function EntryListHead({ sort, sortBy, headLabel, onRequestSort }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? 'right' : 'left'}
            sortDirection={sortBy === headCell.id ? sort : false}
            width={headCell.width || 'auto'}
          >
            <TableSortLabel
              hideSortIcon
              active={sortBy === headCell.id}
              direction={sortBy === headCell.id ? sort : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {sortBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {sort === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
